<template>
  <b-container fluid class="mt-4 p-0">
    <div class="qr-wrapper d-flex align-items-center justify-content-center">
      <div class="d-flex flex-column align-items-center p-4">
        <!-- QR-style grid -->
        <div class="qr-box d-flex flex-wrap justify-content-center align-content-center">
          <div
            v-for="(cell, index) in cells"
            :key="index"
            :class="['qr-cell', cell]"
          ></div>
        </div>

        <!-- Caption line -->
        <div class="caption-line mt-4"></div>
      </div>
    </div>
  </b-container>
</template>

<script>
export default {
  name: "QrPlaceholder",
  data() {
    return {
      cells: [
        "solid", "muted", "solid",
        "muted", "solid", "muted",
        "solid", "solid", "muted"
      ]
    };
  }
};
</script>

<style scoped>
/* Card wrapper */
.qr-wrapper {
  height: 12rem; /* h-48 */
  width: 100%;
  background-color: #ffffff;
  border: 1px solid #f1f1f1;
}

/* Optional dark mode */
body.dark .qr-wrapper {
  background-color: #0b1c2d;
  border-color: rgba(11, 28, 45, 0.5);
}

/* QR container */
.qr-box {
  width: 96px;  /* size-24 */
  height: 96px;
  border: 2px solid #c9a24d;
  padding: 8px;
  gap: 6px;
}

/* QR cells */
.qr-cell {
  width: 16px; /* size-4 */
  height: 16px;
}

.qr-cell.solid {
  background-color: #0b1c2d;
}

.qr-cell.muted {
  background-color: rgba(11, 28, 45, 0.1);
}

/* Dark mode cells */
body.dark .qr-cell.solid {
  background-color: #c9a24d;
}

body.dark .qr-cell.muted {
  background-color: rgba(201, 162, 77, 0.1);
}

/* Bottom line */
.caption-line {
  height: 4px;
  width: 64px;
  background-color: rgba(11, 28, 45, 0.1);
}

body.dark .caption-line {
  background-color: rgba(201, 162, 77, 0.2);
}
</style>
